async function getSCCStationID ( facilityId ) {
    return this.api({
        url: `/cars/quality-assurance/facility/${facilityId}/scc/station-id`,
        method: 'GET'
    })
}

async function submitSCCStationID ( facilityId, stationId ) {
    return this.api({
        url: `/cars/quality-assurance/facility/${facilityId}/scc/station-id`,
        data: { scc_id: stationId },
        method: 'PUT'
    })
}

async function getConfirmedLidars ( facilityId ) {
    return this.api({
        url: `/cars/quality-assurance/facility/${facilityId}/lidars`,
        method: 'GET'
    })
}

async function editSCCLidarID ( lidarId, sccData ) {
    return this.api({
        url: `/cars/quality-assurance/lidar/${lidarId}/scc-id`,
        data: { ...sccData },
        method: 'PATCH'
    })
}

async function submitSCCLidarID ( lidarId, sccData ) {
    return this.api({
        url: `/cars/quality-assurance/lidar/${lidarId}/scc-id`,
        data: { ...sccData },
        method: 'PUT'
    })
}

async function getLidarConfigurations (lidarId) {
    return this.api({ url: `/cars/quality-assurance/lidar/${lidarId}/configurations` })
}

async function putLidarConfigurations (lidarId, options) {
    return this.api({
        url: `/cars/quality-assurance/lidar/${lidarId}/configurations`,
        data: options,
        method: 'PUT'
    })
}

async function getLidarEvaluations (lidarId) {
    return this.api({ url: `/cars/quality-assurance/lidar/${lidarId}/evaluations` })
}

async function postLidarEvaluation (lidarId, options) {
    return this.api({
        url: `/cars/quality-assurance/lidar/${lidarId}/evaluations`,
        data: options,
        method: 'POST'
    })
}

async function getEvaluationTypes () {
    return this.api({
        url: '/cars/types/lidar-qa-evaluation',
        method: 'GET'
    })
}

async function getLidarConfigurationIssueTypes () {
    return this.api({
        url: '/cars/types/lidar-configuration-issue',
        method: 'GET'
    })
}

async function getConfiguration (configurationId) {
    return this.api({
        url: `/cars/quality-assurance/configuration/${configurationId}`,
        method: 'GET'
    })
}

async function startEvaluation (evaluationId) {
    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}`,
        method: 'PATCH',
        data: {
            status: 'new',
            start_date: new Date()
        }
    })
}

async function getEvaluation (evaluationId) {
    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}`,
        method: 'GET'
    })
}

async function requestTestData (evaluationId, options) {
    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}`,
        method: 'PATCH',
        data: {
            ...options,
            status: 'data_requested'
        }
    })
}

async function fetchEvaluatedConfigurationFiles (evaluationId, evaluatedConfigurationId) {
    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}/data/${evaluatedConfigurationId}`,
        method: 'GET'
    })
}

async function uploadEvaluatedConfigurationFile (evaluationId, evaluatedConfigurationId, file) {
    const formData = new FormData()

    formData.append('file', file)

    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}/data/${evaluatedConfigurationId}`,
        data: { file: file },
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

async function removeEvaluatedConfigurationFile (evaluationId, evaluatedConfigurationId, nextcloudFile) {
    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}/data/${evaluatedConfigurationId}`,
        method: 'DELETE',
        data: nextcloudFile
    })
}

async function patchEvaluation (evaluationId, options) {
    const data = Object.fromEntries(Object.entries(options).filter(([f, v]) => v != null && f != null))
    
    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}`,
        method: 'PATCH',
        data: data
    })
}

async function evaluationLog (evaluationId) {
    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}/log`,
        method: 'GET'
    })
}

async function confirmEvaluatedConfiguration (evaluationId, configurationId, newSccId) {
    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}/validate/${configurationId}`,
        method: 'PUT',
        data: {
            scc_id: newSccId
        }
    })
}

async function closeEvaluation (evaluationId) {
    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}/validate`,
        method: 'PUT'
    })
}

async function getSccCsvFile (configurationId) {
    return this.api({
        url: `/cars/quality-assurance/configuration/data/${configurationId}/scc-csv`,
        method: 'GET'
    })
}

async function reprocessEvaluation (evaluationId) {
    return this.api({
        url: `/cars/quality-assurance/evaluation/${evaluationId}/reprocess`,
        method: 'GET'
    })
}

export default {
    pluginName: 'qa',
    methods: {
        getSCCStationID, submitSCCStationID,
        getConfirmedLidars, editSCCLidarID, submitSCCLidarID,
        getLidarConfigurations, putLidarConfigurations,
        getLidarEvaluations, postLidarEvaluation,
        getEvaluationTypes, getLidarConfigurationIssueTypes,
        getConfiguration, getEvaluation,
        startEvaluation, requestTestData,
        fetchEvaluatedConfigurationFiles, uploadEvaluatedConfigurationFile,
        removeEvaluatedConfigurationFile,
        patchEvaluation, evaluationLog,
        confirmEvaluatedConfiguration, closeEvaluation,
        getSccCsvFile,
        reprocessEvaluation
    }
}